export default __webpack_public_path__ + "static/media/donate-04.723ece81.png";